import { useContext } from 'react';
import { SyncPricingOptionsJobContext } from './context';

export default function useSyncPricingOptionsJobContext() {
  return useContext(SyncPricingOptionsJobContext);
}
